import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  createDiagnostics,
  createDiagnosticsByPetId,
  createPrescriptionWoLoader,
  createProcedure,
  updateDiagnostics,
  updatePrescriptionByIdWoLoader,
  updateProcedureById,
  updateProcedureDateAndRemarkById,
} from "../../../redux/reducers/petSlice";
import { diagnosticTypes } from "../../../util/dropList";
import { getOnlyName, getProcedureDetailsNew } from "../../../util/function";

const initValues = {
  type: "Preventive",
  diagType: "Lab",
  service: null,
  variant: null,
  date: new Date(),
  remarks: "",
  addToAppointment: false,
  planItem: "",
};
const initErrs = { service: "", variant: "", planItem: "" };
const defObj = {
  clinic: {},
  services: [],
  stocks: [],
  facilities: [],
  locations: [],
};

const CreateUpdateReminder = ({
  modVsble = false,
  onCloseMod = () => {},
  selectedItem = null,
  selecetdtype = null,
  addToAppointment = false,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { appointment } = location.state || {};
  const [modValues, setModValues] = useState(initValues);
  const [modErrs, setModErrs] = useState(initErrs);
  // const { locationList, facilities } = useSelector((state) => state?.clinic);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appDet = apntDet?.appointment;
  const apntId = appointment?.appoinment?.appointmentId;
  const petId = appointment?.appoinment?.petId;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { services, stocks, clinic, facilities, locations } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        locations: Array.isArray(reqData?.locations) ? reqData?.locations : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    if (!modVsble) return;
    const reqObj = {
      ...initValues,
      type: selecetdtype ?? initValues.type,
      addToAppointment: addToAppointment || initValues.addToAppointment,
      date:
        (selecetdtype === "Diagnostics"
          ? selectedItem?.dueDate
          : selectedItem?.doneAt) ?? new Date(),
      service:
        (selecetdtype === "Diagnostics"
          ? selectedItem?.testName
          : selectedItem?.procedureName) ?? null,
      serviceId: selectedItem?.serviceId ?? null,
      variant:
        (selecetdtype === "Diagnostics"
          ? selectedItem?.variantNumber
          : selectedItem?.serviceType) ?? null,
      variantId:
        (selecetdtype === "Diagnostics"
          ? selectedItem?.variantId
          : selectedItem?.procedureVariantId) ?? null,
      remarks:
        (selecetdtype === "Diagnostics"
          ? selectedItem?.remark
          : selectedItem?.remarks) ?? "",
      planItem: selectedItem?.planItem ?? "",
      category: selectedItem?.category ?? "",
      subCategory: selectedItem?.subCategory ?? "",
      diagType:
        selecetdtype === "Diagnostics" ? (selectedItem?.type ?? "Lab") : null,
    };
    if (selecetdtype === "Diagnostics") {
      const matchServ = services?.find(
        (ser) => ser?.serviceId === selectedItem?.serviceId,
      );
      if (matchServ) {
        const reqVar = matchServ?.serviceVariants?.find(
          (vl) => vl?.variantId === selectedItem?.variantId,
        );
        if (reqVar) reqObj.variant = reqVar?.variantName;
      }
    }
    setModValues(reqObj);
    setModErrs(initErrs);
  }, [modVsble, selecetdtype, addToAppointment, selectedItem]);

  const handleModClose = (typ, catType) => {
    onCloseMod(typ, catType);
  };

  const onChange = (name, value) => {
    const reqObj = { ...modValues, [name]: value };
    const errObj = { ...modErrs };
    if (name === "type") {
      reqObj.service = null;
      reqObj.serviceId = null;
      reqObj.category = null;
      reqObj.subCategory = null;
      reqObj.variant = null;
      reqObj.variantId = null;

      errObj.service = "";
      errObj.variant = "";
      errObj.planItem = "";
    }
    if (name === "service") {
      reqObj.service = value?.value;
      reqObj.serviceId = value?.serviceId;
      reqObj.category = value?.category;
      reqObj.subCategory = value?.subCategory;
      const vrnts = getVarinatList(value?.serviceId);
      reqObj.variant = vrnts?.[0]?.value;
      reqObj.variantId = vrnts?.[0]?.variantId;

      errObj.variant = !vrnts?.[0]?.variantId ? "This field is required" : "";
      errObj.service = !value?.serviceId ? "This field is required" : "";
      errObj.planItem = "";
    }
    if (name === "variant") {
      reqObj.variant = value?.value;
      reqObj.variantId = value?.variantId;

      errObj.variant = !value?.variantId ? "This field is required" : "";
    }
    if (name === "planItem") {
      errObj.planItem =
        value?.length > 0 || reqObj?.serviceId ? "" : "This field is required";
    }
    setModValues(reqObj);
    setModErrs(errObj);
  };

  const getServiceList = () => {
    return services
      ?.filter(
        (sl) =>
          sl?.active === "Y" &&
          (modValues?.type === "Preventive"
            ? sl?.category === "Preventive Care"
            : modValues?.type === "Diagnostics"
              ? sl?.category?.toLowerCase() ===
                modValues?.diagType?.toLowerCase()
              : !["lab", "radiology", "preventive care"].includes(
                  sl?.category?.toLowerCase(),
                )),
      )
      ?.map((ser) => ({
        name: ser?.serviceName,
        value: ser?.serviceName,
        serviceId: ser?.serviceId,
        category: ser?.category,
        subCategory: ser?.subCategory,
      }));
  };

  const getVarinatList = (serId) => {
    if (!serId) return [];
    const reqList = services
      ?.find((ser) => ser?.serviceId === serId)
      ?.serviceVariants?.map((vnt) => ({
        name: vnt?.variantName,
        variantId: vnt?.variantId,
        servicePrice: vnt?.servicePrice,
        value: vnt?.variantName,
        serviceCharge: vnt?.serviceCharge,
        variantNumber: vnt?.variantNumber,
        serviceId: serId,
      }));
    return reqList ?? [];
  };

  const getFieldNotValid = () => {
    const errObj = { ...modErrs };
    if (modValues?.type !== "Care") {
      if (!modValues?.serviceId || !modValues?.variantId) {
        errObj.service = !modValues?.serviceId ? "This field is required" : "";
        errObj.variant = !modValues?.variantId ? "This field is required" : "";
      }
    }
    if (modValues?.type === "Care") {
      if (modValues?.serviceId && !!modValues?.variantId) {
        errObj.variant = !modValues?.variantId ? "This field is required" : "";
      }
      if (!modValues?.serviceId && modValues?.planItem?.length === 0) {
        errObj.planItem = "This field is required";
      }
    }
    setModErrs(errObj);
    return Object.values(errObj)?.some((li) => li?.length > 0);
  };

  const onSubmit = async () => {
    if (getFieldNotValid()) return;
    if (modValues?.type === "Preventive" || modValues?.type === "Care") {
      const data = {
        doneAt: moment(new Date(modValues?.date)).format("YYYY-MM-DD"),
        remarks: modValues?.remarks,
        procedureDetails: [],
        isFromPreventive: modValues?.type === "Preventive",
        planItem: modValues?.planItem,
      };
      if (modValues?.variant) data.serviceType = modValues?.variant;
      if (modValues?.variantId) data.procedureVariantId = modValues?.variantId;
      if (!selectedItem) {
        data.procedureName = modValues?.service;
        data.serviceId = modValues?.serviceId;
        data.category = modValues?.category;
        data.subCategory = modValues?.subCategory;
        data.petId = petId;
        data.status = "Pending";
      }
      if (modValues?.addToAppointment && apntId) {
        data.appointmentId = appointment?.appoinment?.appointmentId;
        const procedureDetailsResult = await getProcedureDetailsNew({
          servId: modValues?.serviceId,
          varntId: modValues?.variantId,
          services: services ?? [],
          clinicStocks: stocks ?? [],
          pharmacyTaxId: clinic?.pharmacyTaxId,
          status: true,
          facilities: facilities ?? [],
          facilityId: appDet?.facilityId,
          patientWorkbook: true,
          locations: locations ?? [],
        });
        const procedureDetails = procedureDetailsResult?.procedureDetails;
        data.procedureDetails = procedureDetails ?? [];
        if (procedureDetailsResult?.prescriptions?.length > 0) {
          const prescriptionData = {
            status: "Pending",
            remark: "",
            prescription: procedureDetailsResult?.prescriptions,
            issue: "",
            paymentId: apntDet?.paymentId ?? null,
          };
          if (apntDet?.prescription?.[0]?.prescriptionId) {
            dispatch(
              updatePrescriptionByIdWoLoader({
                prescriptionId: apntDet?.prescription?.[0]?.prescriptionId,
                data: prescriptionData,
              }),
            );
          } else {
            dispatch(
              createPrescriptionWoLoader({
                appointmentId: appDet?.appointmentId,
                data: prescriptionData,
              }),
            );
          }
        }
        const resServ = services?.data?.find(
          (ser) => ser?.serviceId === modValues?.serviceId,
        );
        const reqVar = resServ?.serviceVariants?.find(
          (vnt) => vnt?.variantId === modValues?.variantId,
        );
        let tax = 0;
        let total = reqVar?.servicePrice ?? 0;
        if (resServ?.taxApplicability?.toLowerCase() === "yes") {
          tax +=
            resServ?.taxApplicability?.toLowerCase() === "yes"
              ? (Number(reqVar?.servicePrice ?? 0) / 100) *
                Number(resServ?.tax ?? 0)
              : 0;
          total += tax;
        }
        const reqQty = 1;
        data.procedureName = resServ?.serviceName;
        data.serviceId = resServ?.serviceId;
        data.category = resServ?.category;
        data.subCategory = resServ?.subCategory;
        data.petId = appDet?.petId;
        data.appointmentId = appDet?.appointmentId;
        data.serviceCharge = reqVar?.servicePrice ?? 0;
        data.serviceType = getOnlyName(reqVar?.variantName);
        data.tax = Number(Number(tax) * Number(reqQty)) ?? 0;
        data.total = Number(Number(total) * Number(reqQty)) ?? 0;
        data.mrpPrice = Number(reqVar?.servicePrice ?? 0);
        data.quantity = Number(reqQty);
        data.patientWorkbook = true;
        data.mainProcedure = true;
        data.hsnSacCode = resServ?.hsnSacCode ?? null;
        data.paymentId = apntDet?.paymentId ?? null;
      }
      if (selectedItem) {
        if (modValues?.addToAppointment) {
          dispatch(
            updateProcedureById({ id: selectedItem?.procedureId, data }),
          ).then((res) => {
            if (res?.payload) handleModClose("apiSuccess", modValues?.type);
          });
        } else {
          dispatch(
            updateProcedureDateAndRemarkById({
              id: selectedItem?.procedureId,
              data: {
                doneAt: moment(new Date(modValues?.date)).format("YYYY-MM-DD"),
                remarks: modValues?.remarks,
                planItem: modValues?.planItem ?? "",
              },
            }),
          ).then((res) => {
            if (res?.payload) handleModClose("apiSuccess", modValues?.type);
          });
        }
      } else {
        dispatch(createProcedure({ data })).then((res) => {
          if (res?.payload) handleModClose("apiSuccess", modValues?.type);
        });
      }
    }
    if (modValues?.type === "Diagnostics") {
      const reqserv = services?.find(
        (ser) => ser?.serviceId === modValues?.serviceId,
      );
      const reqVar = reqserv?.serviceVariants?.find(
        (sv) => sv?.variantId === modValues?.variantId,
      );
      let tax = 0;
      let total = reqVar?.servicePrice ?? 0;
      if (reqserv?.taxApplicability?.toLowerCase() === "yes") {
        tax +=
          reqserv?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVar?.servicePrice ?? 0) / 100) *
              Number(reqserv?.tax ?? 0)
            : 0;
        total += tax;
      }
      const form = new FormData();
      if (apntId && modValues?.addToAppointment) {
        form.append("appId", apntId);
      }
      form.append("type", modValues?.diagType);
      form.append("testName", modValues?.service);
      form.append("sampleCollected", false);
      form.append("price", Number(total ?? 0));
      form.append("tax", Number(tax ?? 0));
      form.append(
        "dueDate",
        moment(new Date(modValues?.date)).format("YYYY-MM-DD"),
      );
      form.append("remark", modValues?.remarks);
      form.append("hsnSacCode", Number(reqserv?.hsnSacCode ?? null));
      form.append("status", "Scheduled");
      if (modValues?.serviceId) {
        form.append("serviceId", modValues?.serviceId);
      }
      if (modValues?.variantId) {
        form.append("variantId", modValues?.variantId);
      }
      if (selectedItem) {
        const metaUpdate = { diagnosticsId: selectedItem?.diagonosticId, form };
        dispatch(updateDiagnostics(metaUpdate)).then((res) => {
          if (res?.payload) handleModClose("apiSuccess", modValues?.type);
        });
      } else {
        dispatch(
          apntId && modValues?.addToAppointment
            ? createDiagnostics({ appointmentId: apntId, form, formData: true })
            : createDiagnosticsByPetId({ petId, form, formData: true }),
        ).then((res) => {
          if (res?.payload) handleModClose("apiSuccess", modValues?.type);
        });
      }
    }
  };

  return (
    <>
      <CustomModal
        open={modVsble}
        onClose={() => handleModClose("close", null)}
        header={selectedItem ? "Update" : "Add"}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Type <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                list={[
                  { name: "Preventive", value: "Preventive" },
                  { name: "Diagnostics", value: "Diagnostics" },
                  { name: "Care", value: "Care" },
                ]}
                value={modValues?.type}
                name="type"
                label=""
                select
                handleChange={(e) => onChange("type", e?.target?.value)}
                disabled={selectedItem}
              />
            </Grid>
            {modValues?.type === "Diagnostics" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-medium fs14">
                  Category <span className="red-color">*</span>
                </Typography>
                <CustomSelect
                  list={diagnosticTypes}
                  value={modValues?.diagType}
                  name="diagType"
                  label=""
                  select
                  handleChange={(e) => {
                    onChange("diagType", e?.target?.value);
                  }}
                  disabled={selectedItem}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Item Name{" "}
                {modValues?.type !== "Care" ? (
                  <span className="red-color">*</span>
                ) : null}
              </Typography>
              <CustomSelect
                list={getServiceList()}
                value={modValues?.service?.value ?? modValues?.service}
                name="service"
                label=""
                newSelect
                handleChange={(e) => onChange("service", e)}
                error={!!modErrs?.service}
                helperText={modErrs?.service}
                disabled={selectedItem}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Variant{" "}
                {modValues?.type !== "Care" ? (
                  <span className="red-color">*</span>
                ) : null}
              </Typography>
              <CustomSelect
                list={getVarinatList(modValues?.serviceId)}
                value={modValues?.variant?.value ?? modValues?.variant}
                name="variant"
                label=""
                newSelect
                handleChange={(e) => onChange("variant", e)}
                error={!!modErrs?.variant}
                helperText={modErrs?.variant}
                disabled={selectedItem}
              />
            </Grid>
            {modValues?.type === "Care" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-medium fs14">
                  Plan Item
                  {!modValues?.serviceId ? (
                    <span className="red-color">*</span>
                  ) : null}
                </Typography>
                <CustomTextField
                  label=""
                  fullWidth
                  handleChange={(e) => onChange("planItem", e?.target?.value)}
                  value={modValues?.planItem}
                  error={!!modErrs?.planItem}
                  helperText={modErrs?.planItem}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Date <span className="red-color">*</span>
              </Typography>
              <CustomTextField
                label=""
                fullWidth
                handleChange={(e) => onChange("date", e?.target?.value)}
                value={modValues?.date}
                mobileDate
              />
            </Grid>
            {apntId &&
            (modValues?.type !== "Care" ||
              (modValues?.type === "Care" && modValues?.serviceId)) ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="mbMin10">
                  <CustomCheckbox
                    label="Add to Appointment"
                    checked={modValues?.addToAppointment}
                    onChange={() =>
                      onChange("addToAppointment", !modValues?.addToAppointment)
                    }
                    // disabled={selectedItem}
                  />
                </div>
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">Remarks</Typography>
              <CustomTextField
                label=""
                fullWidth
                handleChange={(e) => onChange("remarks", e?.target?.value)}
                value={modValues?.remarks}
                multiline
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end mt10">
                <div>
                  <CustomButton text="Submit" smallBtn onClick={onSubmit} />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default CreateUpdateReminder;
